export default __webpack_public_path__ + "static/media/1image.3f334a35.png";